// extracted by mini-css-extract-plugin
export default {"this":"Home-module--this--1wGXn","content":"Home-module--content--1E1zR","logo":"Home-module--logo--D2j2S","button":"Home-module--button--3is0g"};